import { Product } from '../types';

/**
 * Länken i produktetikettens QR-kod: den länk admin angett på produkten
 * (Produkter → Länk i etikettens QR-kod). Utan länk går QR-koden till butiken.
 */
export const DEFAULT_LABEL_URL = 'https://coffeenova.se/shop';

/** Samma gräns som databasens kontroll (products_label_url_check). */
export const LABEL_URL_MAX = 500;

/**
 * Städar det admin skrivit. Tomt blir undefined. Utan http(s):// läggs
 * https:// till, så att "coffeenova.se/espresso" fungerar.
 */
export const normalizeLabelUrl = (raw: string | undefined): string | undefined => {
    const trimmed = (raw || '').trim();
    if (!trimmed) return undefined;
    const withScheme = /^[a-z][a-z0-9+.-]*:/i.test(trimmed) ? trimmed : `https://${trimmed}`;
    // Webbläsarens form (å i domänen blir punycode, mellanslag %20), samma som databasen tar emot.
    try {
        return new URL(withScheme).href;
    } catch {
        return withScheme;
    }
};

/** Felet för en länk, eller null om den är tom eller giltig. */
export const labelUrlError = (url: string | undefined): string | null => {
    if (!url) return null;
    if (url.length > LABEL_URL_MAX) return `Länken får vara högst ${LABEL_URL_MAX} tecken.`;
    try {
        const parsed = new URL(url);
        if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return 'Länken ska börja med https://';
        if (!parsed.hostname.includes('.')) return 'Skriv hela adressen, till exempel coffeenova.se/espresso.';
        return null;
    } catch {
        return 'Det där ser inte ut som en webbadress.';
    }
};

/** Länken som etiketten ska ha: produktens egen om den är giltig, annars butiken. */
export const labelLinkFor = (product?: Pick<Product, 'labelUrl'>): string => {
    const url = product?.labelUrl;
    return url && !labelUrlError(url) ? url : DEFAULT_LABEL_URL;
};
